import { render } from "./expenses-list-modal.vue?vue&type=template&id=2759d152"
import script from "./expenses-list-modal.vue?vue&type=script&lang=js"
export * from "./expenses-list-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__